var TablaEmisiones = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;
  var alturaRenglon = 0;

  (function() {
    datos.opciones.sort(ordenaOpcion);
    var config = new Config(0, {
      top: 40,
      right: 20,
      bottom: 40,
      left: 20
    });
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var tabla = config.getTabla();
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var textos = svg.selectAll("text").data(datos.opciones, function(d) {
        return d.opcion;
      });
      textos
        .enter()
        .append("text")
        .text(function(d) {
          return d.valor;
        })
        .each(function(d) {
          var caja = d3
            .select(this)
            .node()
            .getBBox();
          alturaRenglon = _.max([alturaRenglon, caja.height]);
        });
      alturaRenglon += tabla.distanciaVertical;
      altoVisualizacion = alturaRenglon * (2 + datos.opciones.length);
      var margin = config.getMargin();
      var gMargin = config.getGMargin();
      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, {
    top: 40,
    right: 20,
    bottom: 40,
    left: 20
  });

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;

  var renglones = null;

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }
      main();
    }
  }

  function main() {
    setLeyendas();
    setTabla();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
    /*
    if (el.visible(true) === true) {
      iniciar();
    } else {
      $(window).on("scroll", revisaScroll);
    }
    */
  }

  function revisaScroll() {
    //iniciar();
    //$(window).off("scroll", revisaScroll);
    if (el.visible(true) === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaTabla();
    callback(null, true);
  }

  function setTabla() {
    var tabla = config.getTabla();
    var gCabecera = gGrafica.append("g").attr("class", "cabecera");
    var gCuerpo = gGrafica
      .append("g")
      .attr("class", "cuerpo")
      .attr("transform", "translate(0," + 2 * alturaRenglon + ")");

    renglones = gCuerpo
      .selectAll("g.renglon")
      .data(datos.opciones, function(d) {
        return d.opcion;
      })
      .enter()
      .append("g")
      .attr("class", "renglon")
      .attr("fill", function(d, i) {
        return i % 2 === 0 ? tabla.fondo : "transparent";
      })
      .attr("transform", function(d, i) {
        return "translate(0," + alturaRenglon * i + ")";
      });

    gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", 0)
      .style(tabla.estiloCabecera)
      .text("Medio de transporte");

    var txt = gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", (gMedidas.ancho * 2) / 3)
      .style(tabla.estiloNumeroCabecera);
    txt
      .append("tspan")
      .attr("x", (gMedidas.ancho * 2) / 3)
      .text("Factor de emisión");
    txt
      .append("tspan")
      .attr("x", (gMedidas.ancho * 2) / 3)
      .attr("dy", "1.2em")
      .text("(gCO2/km)");

    txt = gCabecera
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", gMedidas.ancho)
      .style(tabla.estiloNumeroCabecera);

    txt
      .append("tspan")
      .attr("x", gMedidas.ancho)
      .text("Emisiones por pasajero¹");
    txt
      .append("tspan")
      .attr("x", gMedidas.ancho)
      .attr("dy", "1.2em")
      .text("(gCO2/pasajero*km)");

    renglones
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("height", alturaRenglon)
      .attr("width", gMedidas.ancho)
      .attr("opacity", function(d, i) {
        return i % 2 === 0 ? 0.3 : 1;
      });

    renglones
      .append("text")
      .attr("y", alturaRenglon / 2)
      .attr("x", 10)
      .style(tabla.estiloRenglon)
      .text(function(d) {
        return d.etiqueta;
      });

    renglones
      .append("text")
      .attr("class", "valor")
      .attr("y", alturaRenglon / 2)
      .attr("x", (gMedidas.ancho * 2) / 3 - 10)
      .style(tabla.estiloNumeroRenglon)
      .text(function(d) {
        return d.valor;
      })
      .attr("opacity", 0);

    renglones
      .append("text")
      .attr("class", "valor")
      .attr("y", alturaRenglon / 2)
      .attr("x", gMedidas.ancho - 10)
      .style(tabla.estiloNumeroRenglon)
      .text(function(d) {
        var flagAsterisco = d.asterisco || false;
        var asterisco = d.asterisco === true ? "*" : "";
        return d.valorpp + asterisco;
      })
      .attr("opacity", 0);
  }

  function actualizaTabla() {
    renglones
      .selectAll("text.valor")
      .attr("opacity", 0)
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setLeyendas() {
    var titulo = datos.titulo || false;
    if (titulo !== false) {
      svg
        .append("text")
        .style(estilos.titulo)
        .attr("x", 0)
        .attr("y", margin.top)
        .text(titulo);
    }
    var estiloTemp = config.getBarrasHorizontales();
    var yTexto =
      altoVisualizacion - (gMargin.top + gMargin.bottom) + alturaRenglon / 2;
    svg
      .append("text")
      .style(estiloTemp.estiloNota)
      .attr("x", 0)
      .attr("y", yTexto)
      .text(
        '¹Las emisiones se calculan con base en la tasa de ocupación promedio de cada modo de transporte. Las emisiones emitidas por las personas que usan "automóvil", "taxi", y "mototaxi" son calculadas con base en la información real reportada por los encuestados'
      )
      .call(funciones.wrap, medidas.ancho);
    svg
      .append("text")
      .style(estiloTemp.estiloNota)
      .attr("x", 0)
      .attr("y", yTexto + 25)
      .text("*La tasa de ocupación excluye al conductor")
      .call(funciones.wrap, medidas.ancho);
  }

  function ordenaOpcion(a, b) {
    var aTxt = a.etiqueta.toLowerCase();
    var bTxt = b.etiqueta.toLowerCase();
    if (aTxt < bTxt) {
      return -1;
    }
    if (aTxt > bTxt) {
      return 1;
    }
    return 0;
  }

  setup();
};
